import "./App.css"
import { Navigate } from "@/router"

export default function App() {
	return <Navigate to="/report/create/period" replace />
}
